/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No rankings found" |
*
* @param {Rankings_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_no_results = /** @type {((inputs?: Rankings_No_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_No_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun classement trouvé")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron clasificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma classificação encontrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna classifica trovata")
	return /** @type {LocalizedString} */ ("No rankings found")
});